export default {
 taskRecord: {
   title: "작업 보상",
   loading: "로딩 중...",
   empty: "보상이 없습니다",
   completed: "이 작업은 완료되었습니다",
   desc: "작업을 완료하면 보상을 받을 수 있습니다",
   close: "닫기",
   add: "추가",
   addEmail: "이메일 추가",
   addPhoneNumber: "전화번호 추가",
   addBirthday: "생일 추가",
   downloadNow: "지금 다운로드",
   phone: "전화번호",
   email: "이메일 주소",
   bank: "은행 카드",
   birthday: "생일",
   download: "다운로드",
   downloadApp: "APP 다운로드",
   registerBonus: "가입 보너스",
   firstInviteBonus: "첫 초대 보너스",
   invite: "초대",
   inviteNow: "친구 초대",
   go: "이동",
   receive: "받기",
   received: "수령 완료",
   task: "작업",
   claimRewards: '보상 받기',
   receiveSuccess: '보상을 수령했습니다',
   receiveFail: '보상 수령에 실패했습니다'
 }
};
